import { CHAT_MEDIA_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

// Inbound media: mediaKey/mediaType/metaMediaId all-or-nothing (metaMediaId kept for DSGVO DELETE).
// messageId optional — absent on historical events; once Manta mints it, it's shared with the read model/saga table.
export const schemaChatMessageReceivedPayload = z
    .object({
        // Fact of the tap, not its reaction — the saga decides auto-reply later.
        buttonTap: z
            .object({ buttonIndex: z.number().int().nonnegative(), templateName: z.string().min(1) })
            .optional(),
        content: z.string().min(1),
        customerIdentity: z.string().min(1),
        mediaFileName: z.string().min(1).optional(),
        mediaKey: z.string().min(1).optional(),
        mediaType: z.nativeEnum(CHAT_MEDIA_TYPES).optional(),
        messageId: schemaId.optional(),
        metaMediaId: z.string().min(1).optional(),
        metaMessageId: z.string().min(1),
        phoneNumberId: z.string().min(1),
        // Meta context.id; reference not snapshot, so censoring the original censors the quote.
        repliedToMetaMessageId: z.string().min(1).optional(),
        // ms
        sentAt: z.number().int().positive().optional(),
    })
    .refine(
        (data) =>
            Boolean(data.mediaKey) === Boolean(data.mediaType) && Boolean(data.mediaKey) === Boolean(data.metaMediaId),
        {
            message: 'mediaKey, mediaType and metaMediaId must either all be present or all be absent',
        },
    );

export type Schema_ChatMessageReceivedPayload = z.infer<typeof schemaChatMessageReceivedPayload>;
